const sendInsightReport = (func: () => any) => {
  console.info('Oh ya');
  if ((<any>window).DataIntelligenceSubmitScript) {
    func();
  } else {
    if (window.addEventListener) {
      window.addEventListener('decclientready', func, false);
    } else if ((<any>window).attachEvent) {
      (<any>window).attachEvent('decclientready', func);
    }
  }
};

export { sendInsightReport };
